import axios from "axios";

const ENV_BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
// Emergent preview ingress blocks cross-subdomain CORS preflights. Every
// *.preview.emergentagent.com host for this app routes /api to this backend,
// so when the app is served from any preview host we call the API same-origin
// (no CORS at all). In local dev (localhost) we keep using the env URL.
const host = typeof window !== "undefined" ? window.location.host : "";
const onPreviewHost = /\.preview\.emergentagent\.com$/i.test(host);
export const BACKEND_URL = onPreviewHost ? window.location.origin : ENV_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

export function fileUrl(path) {
  if (!path) return "";
  if (path.startsWith("http")) return path;
  return `${API}/public/files/${path}`;
}
export function inr(n) {
  const v = Number(n || 0);
  return "\u20b9" + v.toLocaleString("en-IN");
}

export function apiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
